import React from 'react';
import style from './index.module.scss';
import TaskList from './Compoments/TaskList';
import {Tabs} from 'antd';
import LogList from './Compoments/LogList';
import NavTabs from '../Components/NavTabs';

export default function PageTask() {
    return (
        <div className={style.root}>
            <NavTabs defaultActiveKey="info">
                <Tabs.TabPane tab="任务维护" key="info">
                    <TaskList />
                </Tabs.TabPane>
                <Tabs.TabPane tab="任务日志" key="log">
                    <LogList />
                </Tabs.TabPane>
            </NavTabs>
        </div>
    );
}
